import { axiosInstance, endpoints } from 'src/utils/axios';

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  adminUser?: {
    id: string;
    email: string;
    role: string;
    active: boolean;
    displayName?: string;
    lastLoginAt?: string;
  };
}

interface LoginData {
  email: string;
  password: string;
  host: string;
}

interface RegisterData {
  name: string;
  email: string;
  password: string;
}

export const authRepository = {
  async login(data: LoginData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.admin.auth.login, data);

    if (!response.data) {
      throw new Error('Login failed');
    }

    return response.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.admin.auth.register, data);

    if (!response.data) {
      throw new Error('Registration failed');
    }

    return response.data;
  },

  async refreshAccessToken(refreshToken: string): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.admin.auth.refresh, { refreshToken });

    if (!response.data?.accessToken) {
      throw new Error('Failed to refresh access token');
    }

    return {
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken || refreshToken, // Se não vier novo, usa o atual
    };
  },
};
